import { UploadFile } from "types/storage.types";

export enum ClarificationStatus {
	"draft" = 1,
	"open" = 2,
	"closed" = 3,
	"pending" = 4,
}

export enum ClarificationImpact {
	"financial" = 1,
	"scope" = 2,
	"schedule" = 3,
	"technical" = 4,
	"none" = 5,
}
export interface ClarificationType {
	id: number;
	name: string;
	description?: string;
}

export interface ClarificationLink {
	id: number;
	label: string;
	link_type: "question" | "quote" | "document" | "external";
	url: string;
}

export interface Clarification {
	id: number;
	clarification_impact_id?: ClarificationImpact;
	clarification_text: string;
	clarification_type?: ClarificationType;
	clarification_type_id: number;
	conversation_unread_count?: number;
	created_at: string;
	date_due?: string;
	date_response_sent?: string;
	date_sent?: string;
	files: UploadFile[];
	final_response?: string;
	has_conversation?: boolean;
	is_approved?: boolean;
	is_complete: boolean;
	is_draft_response: boolean;
	is_sent: boolean;
	links?: ClarificationLink[];
	owner: string;
	reference_number: number;
	relates_to?: string;
	rfx_id: number;
	rfx_submission_id: number;
	status: ClarificationStatus;
	supplier_logo?: string | null;
	supplier_name?: string;
	updated_at: string;
}

export interface CreateClarificationPayload {
	clarification_text: string;
	clarification_type_id: number;
	owner: string;
	relates_to?: string;
}

export interface SubmitClarificationResponsePayload {
	final_response?: string;
}

export interface SendResponsesPayload {
	clarification_ids: number[];
}

export interface UpdateClarificationPayload {
	clarification_impact_id?: ClarificationImpact;
	clarification_text?: string;
	clarification_type_id?: number;
	is_complete?: boolean;
	owner?: string;
	relates_to?: string;
	status?: ClarificationStatus;
}

export interface SendClarificationsPayload {
	clarification_ids: number[];
	date_due: string;
}

export interface ImportClarificationError {
	column: string;
	message: string;
	row: number;
}

export interface ImportClarificationsResult {
	errors: ImportClarificationError[];
	imported_count: number;
	success: boolean;
}

export interface ImportClarificationRow {
	id?: number;
	clarification_text: string;
	clarification_type: string;
	clarification_type_id: number;
	deleted?: boolean;
	errors?: Record<string, string[]>;
	impact?: string;
	is_new: boolean;
	owner: string;
	reference_number?: number;
	relates_to?: string;
	row_number: number;
}

export interface ValidateImportResult {
	errors: ImportClarificationError[];
	rows: ImportClarificationRow[];
	success: boolean;
}
